module.exports = (s) => s.toLowerCase();
